import instanceQuery from '../../queries/product/ProductAllocationQuery.graphql';
import mutationQuery from '../../mutations/product/ProductAllocationMutation.graphql';
import fragment from '../../fragments/product/ProductAllocationFragment.graphql';
import workspaceQuery from '../../queries/product/ProductAllocationWorkspaceQuery.graphql';

import { formActions } from 'actions/sales/AllocationAction';

const ProductAllocation = {
  type: 'AllocationSalesHelperContainer',
  title: 'Product Allocation',
  formTitle: 'Product Allocation',
  formUrl: '/Products/ProductAllocation/Details/',
  instance: instanceQuery,
  update: mutationQuery,
  workspace: workspaceQuery,
  fragment,
  screenReference: 'SALES_ORDER_ALLOCATE_STOCK',
  actions: formActions,
};

export default ProductAllocation;
